import { Handle, Position } from 'reactflow'
import { cn } from '@/utils/cn'

export function FluxosPipelineNode({ data, selected }: { data: Record<string, unknown>; selected?: boolean }) {
  const label = String(data.label ?? '')
  const sublabel = data.sublabel ? String(data.sublabel) : undefined
  const color = data.color ? String(data.color) : undefined
  const probability = data.probability !== undefined ? Number(data.probability) : undefined

  return (
    <div
      className={cn(
        'px-3 py-2.5 rounded-lg border-2 transition-all min-w-[170px]',
        selected
          ? 'border-accent bg-accent/10 shadow-[0_0_15px_rgba(94,106,210,0.3)]'
          : 'border-white/10 bg-[#141516] hover:border-white/20',
      )}
    >
      <Handle type="target" position={Position.Left} className="opacity-0" />
      {color && (
        <div
          className="absolute left-0 top-1 bottom-1 w-[3px] rounded-r-full"
          style={{ backgroundColor: color }}
        />
      )}
      <div className="relative pl-2">
        <div className="flex items-center justify-between gap-2">
          <div className="text-xs font-bold text-white mb-0.5">{label}</div>
          {probability !== undefined && (
            <span
              className="text-[9px] font-bold px-1.5 py-0.5 rounded-full shrink-0"
              style={{ backgroundColor: `${color}20`, color }}
            >
              {probability}%
            </span>
          )}
        </div>
        {sublabel && <div className="text-[10px] text-text-muted leading-tight">{sublabel}</div>}
      </div>
      <Handle type="source" position={Position.Right} className="opacity-0" />
    </div>
  )
}

export const fluxosNodeTypes = { custom: FluxosPipelineNode }
